import Swiper from 'swiper';
export default {
  init() {

    var swiper = document.querySelectorAll('.swiper-container-home');
    new Swiper (swiper, {
      spaceBetween: 30,
      //effect: 'fade',
      autoplay: {
          delay: 3000,
      },
      pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets',
      },
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
    });

    $('.gallery-top').each(function(index){
        if($(this).hasClass('gallery-top')) {
            $(this).addClass('g'+index);
        }
    });


    $('.gallery-thumbs').each(function(index){
        if($(this).hasClass('gallery-thumbs')) {
            $(this).addClass('t'+index);
        }
    });

      $('.multi-swiper-box').each(function(index){

        var galleryThumbs = new Swiper('.t'+index, {
          spaceBetween: 10,
          slidesPerView: 4,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
        });

        new Swiper('.g'+index, {
          spaceBetween: 10,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          thumbs: {
            swiper: galleryThumbs,
          },
        });
      });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js